<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData
            :coaching="coachingData"
            :filtersFormated="filtersFormated"
            :calculatedUnits="calculatedUnitsData"/>
        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>
        <Search
            :filters="filters"
            :loading="isSearching"
            @search="getMeetingList"/>

        <div class="table-responsive overflow-auto mt-2">
          <table class="table table-striped table-hover">
            <thead>
            <tr>
              <th style="font-size: 12px;">
                Termin
              </th>
              <th style="font-size: 12px;">
                Anwesenheit
              </th>
              <th class="text-end" style="font-size: 12px;">
                Startzeit
              </th>
              <th class="text-end" style="font-size: 12px;">
                Endzeit
              </th>
              <th class="text-end" style="font-size: 12px;">
                Einheiten
              </th>
              <th class="text-center" style="font-size: 12px;">
                Unterschrift
              </th>
              <th class="text-center" style="font-size: 12px;">
                Hausbesuch
              </th>
              <th style="font-size: 12px;">
                Coach
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="meeting in meetingList" :key="meeting.id">
              <th>{{ meeting.termin }}</th>
              <td>{{ capitalize(meeting.presence) }}</td>
              <td class="text-end">{{ meeting.startTime }}</td>
              <td class="text-end">{{ meeting.endTime }}</td>
              <td class="text-end">{{ meeting.units }}</td>
              <td class="text-center">{{ meeting.signature ? 'JA' : 'NEIN' }}</td>
              <td class="text-center">{{ meeting.homeVisit ? 'JA' : 'NEIN' }}</td>
              <td>{{ meeting?.coachFirstName }} {{ meeting?.coachLastName }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import portalAssistedLivingCoachingService from '@/api/Portal/AssistedLivingCoaching';
import assistedLivingCoachingService from '@/api/Unemployed/AssistedLivingCoaching';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import { piniaUserStore } from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/AssistedLivingCoaching/CoachingOverviewData.vue';
import Search from '@/views/App/Portal/AssistedLivingCoaching/MeetingList/Search.vue';
import Menu from '@/views/App/Portal/AssistedLivingCoaching/Menu.vue';
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const piniaUserState      = piniaUserStore();
const piniaCurrentUser    = computed(() => piniaUserState.currentUser.user);
const route               = useRoute();
const coachingData        = ref('');
const operationType       = ref('');
const calculatedUnitsData = ref('');
const meetingList         = ref([]);
const coachingId          = +route.params.id;
const isLoaded            = ref(false);
const isDigitalSignature  = ref(false);
const isSearching         = ref(false);
const coachingStartDate   = ref(null);
const coachingEndDate     = ref(null);

const filters = ref({
  startDate: '',
  endDate: '',
});

const filtersFormated = ref({
  startDate: '',
  endDate: '',
});

async function getMeetingList(passedFilters) {
  try {
    if (passedFilters) {
      isSearching.value     = true;
      filtersFormated.value = passedFilters;
    }

    const { data }    = await portalAssistedLivingCoachingService.getMeetingList(coachingId, {
      ...(passedFilters ? passedFilters : filters.value),
    });
    meetingList.value = data.data;

    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function getCoachingData() {
  try {
    CloseToast();
    const { data } = await assistedLivingCoachingService.getAssistedLivingCoaching(+coachingId);

    coachingData.value       = data?.data;
    operationType.value      = data?.data?.nameOfCoaching?.operationType;
    isDigitalSignature.value = data.data.digitalSignature;

    const { data: calculatedUnits } = await assistedLivingCoachingService.getCalculatedUnits(+coachingId);
    calculatedUnitsData.value       = calculatedUnits.data;

    filters.value.startDate = data.data.startDate;
    filters.value.endDate   = data.data.endDate;
  } catch (error) {
    await ErrorToast(error);
  }
}

function capitalize(value) {
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
}

onMounted(async () => {
  await Promise.all([
    getCoachingData(),
    getMeetingList(),
  ]);
  isLoaded.value = true;
});
</script>

<style scoped>

</style>